module.exports = __webpack_public_path__ + "static/img/banner-es.0e3b1fa9.png";